import {
  BasicQuestionBlock,
  BodyPage,
  CheckBoxField,
  CheckboxBlock,
  ContentBlock,
  DateField,
  DateOfBirthField,
  EmailField,
  FormBlock,
  FormField,
  FormFieldInputType,
  FormPage,
  MultiChoiceBlock,
  MultiSelectField,
  NPSField,
  RadioField,
  ScaleField,
  SelectField,
  StarRatingField,
  TextAreaField,
  TextField,
} from "../FormTypes";

const CONTENT_BLOCK_TYPES = ["text_content", "image", "video"];
const CHECKBOX_BLOCK_TYPES = ["checkboxes"];
const MULTICHOICE_BLOCK_TYPES = ["multi_choice", "dropdown", "yes_no"];

export const isBodyPage = (page: FormPage): page is BodyPage =>
  page.page_type === "body";

export const isQuestionBlock = (
  block: FormBlock
): block is BasicQuestionBlock =>
  !CONTENT_BLOCK_TYPES.includes(block.block_type);

export const isContentBlock = (block: FormBlock): block is ContentBlock =>
  CONTENT_BLOCK_TYPES.includes(block.block_type);

export const isCheckboxBlock = (block: FormBlock): block is CheckboxBlock =>
  CHECKBOX_BLOCK_TYPES.includes(block.block_type);

export const isMultiChoiceBlock = (
  block: FormBlock
): block is MultiChoiceBlock =>
  MULTICHOICE_BLOCK_TYPES.includes(block.block_type);

// Is a field a numeric type (for comparison purposes)
export const isNumericField = (
  f: FormField
): f is
  | NPSField
  | ScaleField
  | DateField
  | DateOfBirthField
  | StarRatingField => {
  const numericTypes: FormFieldInputType[] = [
    "agree_disagree",
    "nps",
    "star_rating",
    "number",
  ];

  return numericTypes.includes(f.input_type);
};

// Is a field a date type (for comparison purposes)
export const isDateField = (
  f: FormField
): f is DateField | DateOfBirthField => {
  const dateTypes: FormFieldInputType[] = ["date", "dob"];

  return dateTypes.includes(f?.input_type);
};

// Is a field a string type (for comparison purposes)
export const isStringField = (
  f: FormField
): f is TextField | TextAreaField | SelectField | EmailField | RadioField => {
  const textTypes: FormFieldInputType[] = [
    "text",
    "select",
    "textarea",
    "radio",
  ];

  return textTypes.includes(f?.input_type);
};

export const isBooleanField = (f: FormField): f is CheckBoxField => {
  return f?.input_type === "checkbox";
};

export const isMultiStringField = (f: FormField): f is MultiSelectField => {
  return f?.input_type === "multi-select";
};
